import React, { useState, useEffect } from 'react'; // eslint-disable-line
import './AdminPage.css';

import DailyTab from './admin/DailyTab';
import PlayersTab from './admin/PlayersTab';
import TeamsTab from './admin/TeamsTab';
import ReceiptsTab from './admin/ReceiptsTab';
import BigpointTab from './admin/BigpointTab';
import TransactionsTab from './admin/TransactionsTab';
import ClmLogsTab from './admin/ClmLogsTab';
import CampaignReportTab from './admin/CampaignReportTab';
import GaTab from './admin/GaTab';

const TOP_MENU = [
  { key: 'daily', icon: '📊', label: 'สรุปรายวัน' },
  { key: 'players', icon: '👥', label: 'ผู้เล่นทั้งหมด' },
  { key: 'teams', icon: '🏆', label: 'ทีมทั้งหมด' },
  { key: 'ga', icon: '📈', label: 'GA Traffic' },
];

const AUDIT_MENU = [
  { key: 'report', icon: '📑', label: 'Campaign Report' },
  { key: 'receipts', icon: '🧾', label: 'เช็คบิล CLM' },
  { key: 'bigpoint', icon: '🔑', label: 'เช็ค BigPoint' },
  { key: 'transactions', icon: '💰', label: 'Transaction' },
  { key: 'clmLogs', icon: '📋', label: 'CLM Log' },
];

const ADMIN_PASS = 'bigc2026bts';
const AUDIT_PASS = 'session-audit2026';
const AUDIT_SESSION_HOURS = 24;

// role → allowed menu keys + whether audit submenu is visible
const ROLES = {
  'Admin-GM':     { top: ['daily','players','teams','ga'], audit: ['report','receipts','bigpoint','transactions','clmLogs'], showAudit: true },
  'Manager-bc':   { top: ['daily','players','teams','ga'], audit: [], showAudit: false },
  'Callcenter-bc':{ top: ['players','teams'],              audit: [], showAudit: false },
};

const isAuditAuthed = () => {
  const exp = parseInt(localStorage.getItem('bts_audit_auth_exp') || '0', 10);
  return exp && Date.now() < exp;
};

const AdminPage = () => {
  const [authed, setAuthed] = useState(sessionStorage.getItem('bts_admin_auth') === '1');
  const [username, setUsername] = useState(sessionStorage.getItem('bts_admin_user') || '');
  const [userInput, setUserInput] = useState('');
  const [passInput, setPassInput] = useState('');
  const role = ROLES[username];
  const defaultMenu = role ? role.top[0] : 'daily';
  const [activeMenu, setActiveMenu] = useState(defaultMenu);
  const [error, setError] = useState(null);

  // audit submenu
  const [auditOpen, setAuditOpen] = useState(false);
  const [auditAuthed, setAuditAuthed] = useState(isAuditAuthed());
  const [auditPassInput, setAuditPassInput] = useState('');
  const [auditPrompt, setAuditPrompt] = useState(false);

  useEffect(() => {
    if (!authed) return;
    const root = document.getElementById('root');
    if (root) root.classList.add('bts-admin-fullpage');
    return () => { if (root) root.classList.remove('bts-admin-fullpage'); };
  }, [authed]);

  const doLogin = () => {
    if (!ROLES[userInput]) { alert('Username ไม่ถูกต้อง'); return; }
    if (passInput !== ADMIN_PASS) { alert('รหัสผ่านไม่ถูกต้อง'); return; }
    sessionStorage.setItem('bts_admin_auth', '1');
    sessionStorage.setItem('bts_admin_user', userInput);
    setUsername(userInput);
    setActiveMenu(ROLES[userInput].top[0]);
    setAuthed(true);
    setPassInput('');
  };

  const doLogout = () => {
    sessionStorage.removeItem('bts_admin_auth');
    sessionStorage.removeItem('bts_admin_user');
    localStorage.removeItem('bts_audit_auth_exp');
    setAuthed(false);
    setUsername('');
    setUserInput('');
    setPassInput('');
    setAuditAuthed(false);
    setAuditOpen(false);
    setActiveMenu('daily');
  };

  if (!authed) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'Prompt, sans-serif' }}>
        <div style={{ textAlign: 'center', maxWidth: 320, width: '90%' }}>
          <h2>🔒 BTS Admin</h2>
          <input type="text" value={userInput} onChange={e => setUserInput(e.target.value)} placeholder="Username"
            onKeyDown={e => { if (e.key === 'Enter') doLogin(); }}
            style={{ width: '100%', padding: 12, borderRadius: 8, border: '1px solid #ddd', fontSize: 14, marginBottom: 10, boxSizing:'border-box' }} />
          <input type="password" value={passInput} onChange={e => setPassInput(e.target.value)} placeholder="Password"
            onKeyDown={e => { if (e.key === 'Enter') doLogin(); }}
            style={{ width: '100%', padding: 12, borderRadius: 8, border: '1px solid #ddd', fontSize: 14, marginBottom: 10, boxSizing:'border-box' }} />
          <button onClick={doLogin}
            style={{ width: '100%', padding: 12, background: '#459efc', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>เข้าสู่ระบบ</button>
        </div>
      </div>
    );
  }

  // safety: if role missing (e.g. legacy session), force logout
  if (!role) {
    doLogout();
    return null;
  }

  const allowedTop = TOP_MENU.filter(m => role.top.includes(m.key));
  const allowedAudit = AUDIT_MENU.filter(m => role.audit.includes(m.key));
  const canAudit = role.showAudit && allowedAudit.length > 0;

  // guard: if activeMenu not allowed, reset
  const allAllowed = [...role.top, ...role.audit];
  if (!allAllowed.includes(activeMenu)) {
    setActiveMenu(role.top[0]);
  }

  const TAB_MAP = {
    report: CampaignReportTab,
    daily: DailyTab,
    players: PlayersTab,
    teams: TeamsTab,
    ga: GaTab,
    receipts: ReceiptsTab,
    bigpoint: BigpointTab,
    transactions: TransactionsTab,
    clmLogs: ClmLogsTab,
  };
  const ActiveTab = TAB_MAP[activeMenu] || TAB_MAP[role.top[0]];
  const canManage = username === 'Admin-GM';

  const isAuditTab = allowedAudit.some(m => m.key === activeMenu);
  const showAuditList = auditOpen || isAuditTab;

  const submitAuditPassword = () => {
    if (auditPassInput === AUDIT_PASS) {
      const exp = Date.now() + AUDIT_SESSION_HOURS * 60 * 60 * 1000;
      localStorage.setItem('bts_audit_auth_exp', String(exp));
      setAuditAuthed(true);
      setAuditPrompt(false);
      setAuditPassInput('');
      setAuditOpen(true);
    } else {
      alert('รหัสผ่านไม่ถูกต้อง');
    }
  };

  const onAuditMenuClick = () => {
    if (!auditAuthed || !isAuditAuthed()) {
      setAuditAuthed(false);
      setAuditPrompt(true);
    } else {
      setAuditOpen(o => !o);
    }
  };

  const onAuditSubClick = (key) => {
    if (!auditAuthed || !isAuditAuthed()) {
      setAuditAuthed(false);
      setAuditPrompt(true);
      return;
    }
    setActiveMenu(key);
    setError(null);
  };

  return (
    <div className="bts-admin">
      <nav className="bts-admin__sidebar">
        <div className="bts-admin__sidebar-title">BTS Admin</div>
        <div style={{ padding:'0 12px 10px', fontSize:11, color:'rgba(255,255,255,0.6)', textAlign:'center', borderBottom:'1px solid rgba(255,255,255,0.08)', marginBottom:8 }}>
          👤 {username}
        </div>
        {allowedTop.map(m => (
          <button key={m.key} className={`bts-admin__menu-item ${activeMenu === m.key ? 'bts-admin__menu-item--active' : ''}`} onClick={() => { setActiveMenu(m.key); setError(null); }}>
            <span>{m.icon}</span> {m.label}
          </button>
        ))}
        {canAudit && (
          <>
            <button className={`bts-admin__menu-item ${isAuditTab ? 'bts-admin__menu-item--active' : ''}`} onClick={onAuditMenuClick}>
              <span>🔐</span> Audit {showAuditList ? '▼' : '▶'}
            </button>
            {showAuditList && allowedAudit.map(m => (
              <button key={m.key} className={`bts-admin__menu-item ${activeMenu === m.key ? 'bts-admin__menu-item--active' : ''}`} style={{ paddingLeft: 32, fontSize: 13 }} onClick={() => onAuditSubClick(m.key)}>
                <span>{m.icon}</span> {m.label}
              </button>
            ))}
          </>
        )}
        <div style={{ marginTop:'auto', padding:'10px 12px' }}>
          <button onClick={doLogout} style={{ width:'100%', padding:'8px 12px', background:'#E24B4A', color:'#fff', border:'none', borderRadius:6, fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>
            🚪 ออกจากระบบ
          </button>
        </div>
      </nav>
      <main className="bts-admin__content">
        {error && <div className="bts-admin__alert bts-admin__alert--error">{error} <button onClick={() => setError(null)} style={{ marginLeft: 8, border: 'none', background: 'none', cursor: 'pointer' }}>✕</button></div>}
        <ActiveTab key={activeMenu} onError={setError} canManage={canManage} />
      </main>

      {/* Audit password popup */}
      {auditPrompt && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999 }}>
          <div style={{ background:'#fff', borderRadius:12, padding:24, maxWidth:340, width:'90%', textAlign:'center', fontFamily:'Prompt, sans-serif' }}>
            <h3 style={{ margin:'0 0 12px' }}>🔐 ยืนยันสิทธิ์ Audit</h3>
            <p style={{ fontSize:13, color:'#666', marginBottom:12 }}>กรุณาใส่รหัสผ่านเพื่อเข้าใช้งาน (จำได้ 24 ชม.)</p>
            <input type="password" autoFocus value={auditPassInput} onChange={e => setAuditPassInput(e.target.value)} placeholder="Audit Password"
              onKeyDown={e => { if (e.key === 'Enter') submitAuditPassword(); }}
              style={{ width:'100%', padding:12, borderRadius:8, border:'1px solid #ddd', fontSize:14, marginBottom:10 }} />
            <div style={{ display:'flex', gap:8, justifyContent:'center' }}>
              <button onClick={submitAuditPassword} style={{ flex:1, padding:'10px 16px', background:'#459efc', color:'#fff', border:'none', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer' }}>ยืนยัน</button>
              <button onClick={() => { setAuditPrompt(false); setAuditPassInput(''); }} style={{ flex:1, padding:'10px 16px', background:'#888', color:'#fff', border:'none', borderRadius:8, fontSize:14, cursor:'pointer' }}>ยกเลิก</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPage;
